import { render, staticRenderFns } from "./joinInfo.vue?vue&type=template&id=6e37df02&scoped=true&"
import script from "./joinInfo.vue?vue&type=script&lang=js&"
export * from "./joinInfo.vue?vue&type=script&lang=js&"
import style0 from "./joinInfo.vue?vue&type=style&index=0&id=6e37df02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e37df02",
  null
  
)

export default component.exports